const Footer = () => {
  return (
    // <footer className="bg-gray-100 border-t mt-12 py-4 text-center text-sm text-gray-600">
    <footer className="bg-blue-50 border-t mt-12 py-4 text-center text-sm text-blue-700">
      <p className="font-bold text-blue-600 text-xl">Mtew.</p>
      <p className="mt-2">&copy; 2024 mtew.org. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
